import type { ReactNode } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Shell from './Shell';
import { Loading } from './ui';
import { useMe } from './hooks';
import Login from './pages/Login';
import LoginLink from './pages/LoginLink';
import Termine from './pages/Termine';
import Kalender from './pages/Kalender';
import WasIstNeu from './pages/WasIstNeu';
import Hilfe from './pages/Hilfe';
import FeedbackAdmin from './pages/FeedbackAdmin';
import { AuditLog, DebugLog } from './pages/Admin';
import Flohmarkt from './pages/Flohmarkt';
import ArticleDetail from './pages/ArticleDetail';
import ArticleForm from './pages/ArticleForm';
import Mitglieder from './pages/Mitglieder';
import MemberDetail from './pages/MemberDetail';
import MemberForm from './pages/MemberForm';
import Mitteilungen from './pages/Mitteilungen';
import PostForm from './pages/PostForm';
import EventDetail from './pages/EventDetail';
import EventForm from './pages/EventForm';
import Profil from './pages/Profil';

function RequireLogin({ children }: { children: ReactNode }) {
  const { data: me, isLoading } = useMe();
  const loc = useLocation();
  if (isLoading) return <Loading />;
  if (!me) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  return <>{children}</>;
}

const guard = (el: ReactNode) => <RequireLogin>{el}</RequireLogin>;

export default function App() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '')}>
      <Routes>
        <Route element={<Shell />}>
          <Route path="/login" element={<Login />} />
          <Route path="/hilfe" element={<Hilfe />} /> {/* readable before signing in */}
          <Route path="/login/link" element={<LoginLink />} />
          <Route path="/" element={guard(<Termine />)} />
          <Route path="/termine/neu" element={guard(<EventForm />)} />
          <Route path="/termine/:id" element={guard(<EventDetail />)} />
          <Route path="/termine/:id/bearbeiten" element={guard(<EventForm />)} />
          <Route path="/profil" element={guard(<Profil />)} />
          <Route path="/kalender" element={guard(<Kalender />)} />
          <Route path="/neu" element={guard(<WasIstNeu />)} />
          <Route path="/feedback" element={<Navigate to="/admin/feedback" replace />} />
          <Route path="/admin" element={<Navigate to="/admin/aktionen" replace />} />
          <Route path="/admin/feedback" element={guard(<FeedbackAdmin />)} />
          <Route path="/admin/aktionen" element={guard(<AuditLog />)} />
          <Route path="/admin/debug" element={guard(<DebugLog />)} />
          <Route path="/flohmarkt" element={guard(<Flohmarkt />)} />
          <Route path="/flohmarkt/neu" element={guard(<ArticleForm />)} />
          <Route path="/flohmarkt/:id" element={guard(<ArticleDetail />)} />
          <Route path="/flohmarkt/:id/bearbeiten" element={guard(<ArticleForm />)} />
          <Route path="/mitglieder" element={guard(<Mitglieder />)} />
          <Route path="/mitglieder/neu" element={guard(<MemberForm />)} />
          <Route path="/mitglieder/:id" element={guard(<MemberDetail />)} />
          <Route path="/mitglieder/:id/bearbeiten" element={guard(<MemberForm />)} />
          <Route path="/mitteilungen" element={guard(<Mitteilungen />)} />
          <Route path="/mitteilungen/neu" element={guard(<PostForm />)} />
          <Route path="/mitteilungen/:id/bearbeiten" element={guard(<PostForm />)} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
